import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NoticiaCategoryVM } from "../../../../types/viewModels/cmsPublic";
import "./styles.scss";

const DEBOUNCE_MS = 400;

export interface NewsFiltersProps {
  query: string;
  category: string;
  categories: NoticiaCategoryVM[];
  onQueryChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onClear: () => void;
}

const NewsFilters: React.FC<NewsFiltersProps> = ({
  query,
  category,
  categories,
  onQueryChange,
  onCategoryChange,
  onClear,
}) => {
  const { t } = useTranslation("news");
  const [draftQuery, setDraftQuery] = useState(query);

  // La búsqueda vive en la URL, así que hay que resincronizar si el usuario
  // limpia filtros o navega con el botón atrás.
  useEffect(() => {
    setDraftQuery(query);
  }, [query]);

  useEffect(() => {
    if (draftQuery === query) {
      return;
    }

    const timeout = setTimeout(() => onQueryChange(draftQuery), DEBOUNCE_MS);
    return () => clearTimeout(timeout);
  }, [draftQuery, query, onQueryChange]);

  const hasFilters = Boolean(query || category);

  return (
    <div className="w-100 news-filters shadow d-flex flex-column flex-lg-row gap-3 align-items-lg-end mb-4">
      <Form.Group className="flex-grow-1" controlId="news-search">
        <Form.Label className="news-filters-label">
          {t("searchLabel")}
        </Form.Label>
        <Form.Control
          type="search"
          value={draftQuery}
          placeholder={t("searchPlaceholder")}
          onChange={(event) => setDraftQuery(event.target.value)}
        />
      </Form.Group>

      <Form.Group className="news-filters-category" controlId="news-category">
        <Form.Label className="news-filters-label">
          {t("filterByCategory")}
        </Form.Label>
        <Form.Select
          value={category}
          onChange={(event) => onCategoryChange(event.target.value)}
        >
          <option value="">{t("allCategories")}</option>
          {categories.map((item) => (
            <option key={item.slug} value={item.slug}>
              {item.nombre || item.slug}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Button
        className="custom-primary-button news-filters-clear"
        disabled={!hasFilters}
        onClick={onClear}
      >
        {t("clearFilters")}
      </Button>
    </div>
  );
};

export default NewsFilters;
